const button = {
  changeStyle: 'Changer le style',
};

export default {
  button,
};
